export const DOMAIN = "/"
export const RELEASE_NUM = "CAF-26.01.0994"
export const MODULE_NAME = "cafe-web"
export const IS_ONLINE = true
